import React, { useState, useEffect } from "react";
import { Col, Row, Button, message, Collapse, Modal, Input, Breadcrumb, Tabs, Typography, Result, Space } from "antd";
import { useSelector, useDispatch } from 'react-redux';
import Header from '../../component/dashboard/header'
import { useHistory, useLocation } from 'react-router-dom'
import { bookcover, bookpath, saveandremovefav, bookdetails, favoriteURL, subscriptionURL, passcodevalidation, serverurl,bookavilable } from '../../api/api';
import { RWebShare } from "react-web-share";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { ReadOutlined, ArrowLeftOutlined, FilePdfOutlined, CopyOutlined, BarcodeOutlined, HeartFilled, LoadingOutlined, CalendarOutlined, DownloadOutlined, ShareAltOutlined, ShoppingCartOutlined, BookOutlined, LoginOutlined } from '@ant-design/icons';
import "antd/dist/antd.css";
import './styles.css';
import moment from "moment";
import { FaShoppingCart } from "react-icons/fa";
import PageHader from "../../component/pageheader/pageHeader";
import Offline from "../error/offline";
import { useParams } from "react-router-dom";
import { YM_LOGIN_URL } from "../../api/content-novareader";

const { TabPane } = Tabs;
const { Title } = Typography;
const { TextArea } = Input;
const { Panel } = Collapse;

const NewDescription = (props) => {
    const isOnline = navigator.onLine; // Check online status
    const location = useLocation();
    const { isbn } = useParams();

    const history = useHistory();
    const dispatch = useDispatch();
    const lpp_userCredentials = JSON.parse(localStorage.getItem('lpp_userCredentials'));
    const [description, setdescription] = useState('');
    const [loadings, setloadings] = useState(false);
    const [loading, setloading] = useState(false);
    const [subloading, setsubloading] = useState(false);
    const [likeiconcolor, setlikeiconcolor] = useState('#E8E4E4')
    const [isfavorite, setisfavorite] = useState(false)
    const [book, setbook] = useState({})
    const [isfree, setisfree] = useState(77)
    const [bookaccess, setbookaccess] = useState("77")
    const [issub, setissub] = useState(false)
    const [visible, setVisible] = useState(false);
    const [readervisible, setreadervisible] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [modalText, setModalText] = useState('Content of the modal');
    const [password, setpassword] = useState("")
    const [ispasswordvalid, setispasswordvalid] = useState(false)
    const [isbtnloading, setsbtnloading] = useState(false)
    const [isuserclickbuy, setuserclickbuy] = useState(false)
    const [authors, setauthors] = useState([])
    const [contributors, setContributors] = useState([])
    const [textParts, setTextParts] = useState([])
    const [toc, settoc] = useState()
    const [error, seterror] = useState(false)
    const [format, setformat] = useState('')
    const [pdf, setpdf] = useState(false)
    const [epub, setepub] = useState(false)
    const [rating, setrating] = useState('')
    const [feedback, setfeedback] = useState(' ')
    const [pricing, setpricing] = useState([])
    const [seletedformet, setseletedformet] = useState()
    const [authorBio, setAuthorBio] = useState('')
    const [userCredentials, setUserCredentials] = useState(null);

    const fetchUserCredentials = () => {
        try {
          return JSON.parse(localStorage.getItem("lpp_userCredentials")) || null;
        } catch (error) {
          console.error("Error parsing user credentials:", error);
          return null;
        }
    };

    useEffect(() => {
      window.scrollTo(0, 0);
      const credentials = fetchUserCredentials();
      setUserCredentials(credentials);
    }, []);

    // Handle state change based on online status and user credentials
    useEffect(async () => {
        
        if (isOnline) {
            if (userCredentials === null) {
                getBookdeltaisno() 
            } else {
                await Promise.all([
                    getBookdeltais(userCredentials.apiKey),
                    getSub(userCredentials.apiKey),
                    getFavorite(userCredentials.apiKey),
    
                ])
            }
        } else {
            handleOfflineState();
        }
    }, [isOnline, userCredentials]); 
  
    const handleOfflineState = () => {
    };

    const refreash = async () => {
        setbook({})
        setdescription('')
        setbookaccess("77")
        setisfavorite(false)
        setissub(false)
        await Promise.all([
            getBookdeltais(),
            getFavorite(lpp_userCredentials.apiKey),
            getSub(lpp_userCredentials.apiKey),
        ])
    }

    const getBookdeltais = (apikey) => {
        setloading(true)
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            headers: {
                'apikey': apikey
            }
        };
        fetch(bookdetails + isbn, requestOptions)
            .then(response => response.json())
            .then(result => {
                let getauthors = !result.authors ? "no athore" : result.authors.map(item => item.surName+" "+item.givenName)
                setbook(result.content)
                setdescription(result.desc)
                setbookaccess(result.content.access)
                setAuthorBio(result.authorBio)
                setpricing(result.contentFormats)
                setauthors(getauthors)
                setContributors(result.authors);
                settoc(result.toc)
                setloading(false)
                setTextParts(result.textParts);


            })
            .catch(error => {

                seterror(true)
                setloading(false)

            });
    }
    const getBookdeltaisno = () => {
        setloading(true)
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',

        };
        fetch(bookdetails + isbn, requestOptions)
            .then(response => response.json())
            .then(result => {
                let getauthors = !result.authors ? "no athore" : result.authors.map(item => item.surName+" "+item.givenName)
                setbook(result.content)
                setdescription(result.desc)
                setbookaccess(result.content.access)
                setAuthorBio(result.authorBio)

                setpricing(result.contentFormats)
                setContributors(result.authors);
                setauthors(getauthors)
                settoc(result.toc)
                setloading(false)
                setTextParts(result.textParts);

            })
            .catch(error => {
                console.log(error)

                seterror(true)
                setloading(false)

            });
    }
    const getFavorite = async (apikey) => {
        let axios = require('axios');
        let config = {
            method: 'get',
            url: favoriteURL,
            headers: {
                'apikey': apikey
            }
        };
        axios(config)
            .then((response) => {

                if (response.data.data.length > 0) {
                    let isValuefound = response.data.data.filter(obj => obj.identifier === isbn);
                    if (isValuefound.length > 0) {
                        setisfavorite(true)
                    } else {
                        setisfavorite(false)
                    }


                } else {
                    setisfavorite(false)

                }

            })
            .catch(function (error) {

            });
    }

    const goTopdf = () => {
        history.push({ pathname: '/read/book/pdf/' + book.elasticId, state: { contentid: book.contentId, fuzzyid: book.fuzzyId, isbn: isbn, name: book.fullName, type: "book", isonline: 'yes', cover: book.cover,info:book,auth:authors } })
    }

    const goToepub = () => {
        history.push({ pathname: '/read/book/epub/' + book.elasticId, state: { contentid: book.contentId, isbn: isbn, name: book.fullName, type: "book", fuzzyid: book.fuzzyId, cover: book.cover,info:book,auth:authors } })
    }

    const getSub = async (apikey) => {
        setsubloading(true)
        let axios = require('axios');
        let config = {
            method: 'get',
            url: subscriptionURL,
            headers: {
                'apikey': apikey
            }
        };
        axios(config)
            .then((response) => {
                if (response.data.data.length > 0) {
                    let isValuefound = response.data.data.filter(obj => obj.identifier === isbn);
                    if (isValuefound.length > 0) {
                        console.log(isValuefound)
                        setformat(isValuefound[0].format)
                        setsubloading(false)
                        setissub(true)
                    } else {
                        setsubloading(false)
                        setissub(false)
                    }

                } else {
                    setsubloading(false)
                    setissub(false)

                }

            })
            .catch(function (error) {
                localStorage.removeItem('lpp_userCredentials');
                console.log(error)
                setsubloading(false)
                setissub(false)
            });
    }

    const showModal = () => {
        setVisible(true);
    };

    const handleCancelreader = () => {
        console.log('Clicked cancel button');
        setreadervisible(false);
    };
    const onChange = e => {
        setpassword(e.target.value)
        console.log('Change:', e.target.value);
    };
    const Change = (key) => {
        console.log(key);
    };
    const contentClickHandler = (e) => {
        const targetLink = e.target.closest('a');
        if (!targetLink) return;
        e.preventDefault();

        console.log(targetLink.href);
    }
    const GoToreader = (item) => {
        if (bookaccess == 2 && !issub) {
            setseletedformet(item)
            showModal()

        } else if (issub || bookaccess == 1) {
            if (item.format == "EPUB") {
                goToepub()
            }
            if (item.format == "PDF") {
                goTopdf()
            }
        }
    }

    const handleChangerate = value => {
        setrating(value)
    };
    const onChangefeed = e => {
        setfeedback(e.target.value)
        console.log('Change:', e.target.value);
    };

    const avilableNotifiction = () => {
        const axios = require('axios');
        let data = JSON.stringify([
            {
                "name": "user",
                "label": "User",
                "value": lpp_userCredentials.displayName
            },
            {
                "name": "email",
                "label": "Email",
                "value": lpp_userCredentials.email
            }
        ]);

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: bookavilable,
            headers: {
                'apikey': lpp_userCredentials.apikey,
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                message.info('We will inform to you when the book is live.');



            })
            .catch((error) => {
                console.log(error);
            });

    }

    const toLogin = () => {
        window.location.href = YM_LOGIN_URL;
    }

    const readui=(item)=>{
        if(item.format=="PAPERBACK") {
            return(
                <h4 onClick={()=>{ window.open(serverurl + "book/isbn/" + book.isbn, "_blank")}}><span className="curren">{item.currency+" "}</span>{item.vat.grossPrice} <FaShoppingCart className="cardicon" /></h4>        
            )
        }
        console.log('lpp_userCredentials', lpp_userCredentials);
        if(item.format=="EPUB") {
            if((item.accessType!=null && item.accessType==1)) {
                return (
                    <div className="icons">
                        <Button type="primary" icon={<ReadOutlined />} onClick={goToepub} className="start-reading-btn cls-btn">
                            Read
                        </Button>
                    </div>            
                )
            }       
        }
        if(item.format=="PDF"){
            if((item.accessType!=null && item.accessType==1)) {
                return (
                    <div className="icons">
                        <Button type="primary" icon={<ReadOutlined />} onClick={goTopdf} className="start-reading-btn cls-btn">
                            Read
                        </Button>
                    </div>
                )
            }
        }
    }

    if (loading || subloading) {
        return (
            <div className="continer">
                <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>

                <PageHader titel={book.fullName}/>

                    <Row className="listcontiner" style={{ "padding": "0px", "margin": "0px 0px 0px 0px", padding: '5px', borderRadius: "5px" }}>
                        <div style={{ width: '100%', alignItems: 'center', display: 'flex', flexDirection: 'column',marginTop:'15px' }}>
                            <Skeleton width={280} height={300} />
                            <div style={{ height: "10px", width: '100%' }}></div>
                            <Skeleton width={230} height={25} />
                            <div style={{ height: "10px", width: '100%' }}></div>

                            <Skeleton width={300} height={10} count={5} />
                            <div style={{ height: "10px", width: '100%' }}></div>
                            <Skeleton width={230} height={25} />
                            <div style={{ height: "5px", width: '100%' }}></div>

                            <Skeleton width={230} height={25} />



                        </div>


                    </Row>
                </Col>
            </div>
        )
    }

    if (error) {
        return (
            <div className="continer" >
                <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>

                <PageHader titel={book.fullName}/>

                    <Result
                        status="500"
                        title="500"
                        subTitle="Sorry, something went wrong."
                        extra={<Button onClick={() => { history.goBack() }} type="primary">Back</Button>}
                    />
                </Col>
            </div>
        )
    }


    const LoginButton = () => {
        if (lpp_userCredentials!=null) {
            return null;
        }
        return (
            <div className="icons" style={{ background: "none" }}>
                <Button type="primary" icon={<LoginOutlined />} onClick={toLogin} className="start-reading-btn cls-btn">
                Sign In for Ebook Access
                </Button>
            </div>    
        );  
    }    

    const AccordionTabs = () => {
        return (
            <Collapse defaultActiveKey={['0']} accordion>
              {textParts.map((tab, index) => (
                <Panel 
                  header={tab.tabDisplayName} 
                  key={index}
                  style={{ fontSize: '18px', backgroundColor: '#f0f0f0', border: '1px solid #f0f0f0' }}  // Grey background
                >
                   <div style={{ fontSize: '16px' }} dangerouslySetInnerHTML={{ __html: tab.description }} />
                </Panel>
              ))}
            </Collapse>
        );  
    }    
    
    const ISBNUtils = {
        validateAndFormat: (isbn) => {
            isbn = isbn.replace("-", "");
            if (isbn.trim().length === 13) {
                return isbn.replace(/^(\d{3})(\d{1})(\d{4})(\d{4})(\d)$/, '$1-$2-$3-$4-$5');
            }
            return isbn;
        },
    };
    if (!isOnline) {
        return (
            <div className="continer" >
                <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>
                    <PageHader titel={book.fullName}/>
                    <Offline />
                </Col>
            </div>
        );
    }
    if (isOnline) {
        return (

            <div className="continer">
                <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>

                <PageHader titel={book.fullName}/>

                    <Row className="listcontiner" style={{ "padding": "0px", "margin": "0px 0px 0px 0px", padding: '5px', borderRadius: "5px" }}>
                        <div style={{ width: '100%',marginTop:'15px'}}>
                            <div style={{ width: '100%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                                <img className="dcover" src={bookcover + book.fuzzyId + "/" + book.cover} />
                            </div>
                            <div style={{ display: 'flex', marginBottom: '20px', marginTop: '5px', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ textAlign: 'center', fontSize: '20px', letterSpacing: '1px', fontFamily: 'var(--font)', color: '#000', fontWeight: 'bold' }}>{book.fullName}</div>

                                <div style={{ textAlign: 'center', fontSize: '16px', fontFamily: 'var(--font)', color: '#273746' }}>
                                    <span style={{ color: '#B11116', fontWeight: 'bold' }}>Editors: </span>                                
                                    {contributors.map((contributor, index) => (
                                    <span key={index}>
                                        {contributor.givenName} {contributor.surName}
                                        {contributor.suffix ? `, ${contributor.suffix}` : ''}
                                        {index < contributors.length - 1 && '; '}
                                    </span>
                                    ))}
                                </div>
                                <div style={{ textAlign: 'center', fontSize: '16px', fontFamily: 'var(--font)', color: '#273746' }}><span key="date" style={{ color: '#B11116', fontWeight: 'bold' }}>Publication Date: </span>{moment(book.pubDate).format("MMMM DD, YYYY")}</div>
                                <div key="page" style={{ textAlign: 'center', fontSize: '16px', fontFamily: 'var(--font)', color: '#273746' }}><span style={{ color: '#B11116', fontWeight: 'bold' }}>Pages: </span>{book.pages}</div>                            

                                <>
                                    {pricing.map((item) => {
                                        return (
                                            <>
                                                <div className="reader-card">
                                                    <div className="reader-card-info">
                                                        <h3>{item.displayName}</h3>
                                                        <p><span><b>ISBN</b> </span>{ISBNUtils.validateAndFormat(book.identifier)}</p>
                                                    </div>
                                                    {item.onixStatus == '04' && <div className="icon-continer">
                                                        {readui(item)}
                                                    </div>}
                                                    {item.onixStatus == '02' || item.onixStatus == '02a' ? <div className="icon-continer">
                                                        <p className="notifibtn" onClick={()=>{if(lpp_userCredentials){avilableNotifiction()}else{history.push('/login')}}}>Notify when available</p>
                                                    </div>:null}
                                                </div>
                                            </>)
                                    })}

                                </>


                            </div>
                            <LoginButton />
                            <div style={{ height: "20px", width: '100%' }}></div>
                            <AccordionTabs />
                        </div>
                        <Modal
                            title={<Title style={{ fontFamily: 'var(--font)', letterSpacing: '1px', fontWeight: 'bold', fontSize: '15px' }}>Select Reader</Title>}
                            visible={readervisible}
                            footer={null}
                            onCancel={handleCancelreader}>
                            <div>
                                <p style={{ fontFamily: 'var(--font)', letterSpacing: '1px' }} onClick={() => { goToepub() }}> <ReadOutlined style={{ fontSize: '15px', marginTop: '10px', color: 'blue', marginRight: '10px', fontFamily: 'var(--font)', letterSpacing: '1px' }} />Epub</p>
                                <p style={{ fontFamily: 'var(--font)', letterSpacing: '1px' }} onClick={() => { goTopdf() }}> <FilePdfOutlined style={{ fontSize: '15px', marginTop: '10px', color: 'red', marginRight: '10px', fontFamily: 'var(--font)', letterSpacing: '1px' }} />Pdf</p>
                            </div>
                        </Modal>
                    </Row>
                </Col>
            </div>
        );
    }
}

export default NewDescription;